import BranchAPI from "./API/BranchAPI";
import MembershipAPI from "./API/MembershipAPI";
import AboutAPI from "./API/AboutAPI";
import ProgramAPI from "./API/ProgramAPI";
import VenueHireAPI from "./API/VenueHireAPI";
import ArticleAPI from "./API/ArticleAPI";
import ServiceMenuAPI from "./API/ServiceMenuAPI";
import FaqAPI from "./API/FaqAPI";
import ContactAPI from "./API/ContactAPI";
import LandingPageAPI from "./API/LandingPageAPI";
import SearchAPI from "./API/SearchAPI";
import FreePageAPI from "./API/FreePageAPI";
export default {
    BranchAPI,
    MembershipAPI,
    AboutAPI,
    ProgramAPI,
    VenueHireAPI,
    ArticleAPI,
    ServiceMenuAPI,
    FaqAPI,
    ContactAPI,
    LandingPageAPI,
    SearchAPI,
    FreePageAPI
}
